import React from 'react';
import { useHistory } from 'react-router-dom';

const ChatSelector = () => {
  const history = useHistory(); // ✅ en v5 es useHistory

  const grupos = [
    { id: 'amigos', nombre: 'Grupo de Amigos' },
    { id: 'estudio', nombre: 'Estudio' },
    { id: 'trabajo', nombre: 'Trabajo' },
  ];

  return (
    <div className="p-4">
      <h4>Selecciona un grupo:</h4>
      <div className="d-flex flex-wrap gap-3">
        {grupos.map(grupo => (
          <button
            key={grupo.id}
            className="btn btn-primary"
            onClick={() => history.push(`/grupos-de-chats/${grupo.id}`)} // 👈 Cambiar navigate por history.push
          >
            {grupo.nombre}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChatSelector;
